class Unit {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      unitId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allUnits.length; i++) {
          if (this.allUnits[i].id == 0) {
            return;
          }
        }
        this.allUnits.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allUnits;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allUnits = [];
        this.allUnits = temp;
        this.getUnitFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.unit = new Unit('');
      for (var i = 0; i < this.allUnits.length; i++) {
        if (this.allUnits[i].id == id) {
          if (id == 0) {
            this.allUnits.splice(i, 1);
          }
          this.allUnits[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addUnitFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش واحد';
        this.$refs.confirm.text = 'از ویرایش واحد اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف واحد';
        this.$refs.confirm.text = 'از حذف واحد اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addUnitFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editUnitFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteUnitFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.unitId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
